/** 不需觸發登出的路徑（登入／註冊等未帶有效 session 的請求） */
const AUTH_EXEMPT_PATHS = [
  "adminUsers/login",
  "adminUsers/v2/register",
  "adminUsers/validateEmailToken",
  "adminUsers/forgotPassword",
  "adminUsers/resetPassword",
  "adminUsers/sendResetPasswordEmail",
];

let onUnauthorized = null;
let logoutTriggered = false;

export function registerAuthSessionHandler(handler) {
  onUnauthorized = handler?.onUnauthorized ?? null;
  logoutTriggered = false;
}

export function unregisterAuthSessionHandler() {
  onUnauthorized = null;
  logoutTriggered = false;
}

export function resetUnauthorizedLogoutGuard() {
  logoutTriggered = false;
}

export function shouldTriggerUnauthorizedLogout(url, config = {}) {
  if (!url) return false;

  const headers = config.headers || {};
  const authHeader = headers.Authorization || headers.authorization;
  if (!authHeader || !String(authHeader).startsWith("Bearer ")) {
    return false;
  }

  const normalizedUrl = String(url);
  return !AUTH_EXEMPT_PATHS.some((path) => normalizedUrl.includes(path));
}

/** 帶 Bearer token 的 API 回 401 時，觸發一次登出（例如 token 被後端緊急撤銷）；code 為後端錯誤代碼，例如 SESSION_REVOKED */
export function notifyUnauthorizedResponse({ url, status, code, config } = {}) {
  if (status !== 401) return;
  if (!shouldTriggerUnauthorizedLogout(url, config)) return;
  if (!onUnauthorized || logoutTriggered) return;

  logoutTriggered = true;
  onUnauthorized({ url, status, code });
}
